import { render, staticRenderFns } from "./ImportTicket.vue?vue&type=template&id=b731b4f8"
import script from "./ImportTicket.vue?vue&type=script&lang=js"
export * from "./ImportTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports